import React, { useState, useEffect, useRef } from 'react';
import { useForm } from "react-hook-form";
import { collection, collectionGroup,  query, where,  getDocs} from "firebase/firestore"; 
import { db } from "../firebase-config";
import Financeurs from "./Financeurs";
import {AiOutlineInfoCircle} from "react-icons/ai";
import { Link } from 'react-router-dom';

const MurDesOffres = () => {

    const [offer, setOffer] = useState([])
      
    const [user, setUser] = useState(false)
    const formRef = useRef()
    const [nom, setNom] = useState("")
    const [modal, setModal] = useState(false)


    useEffect(() =>  {
        setOffer([]);
        loadOfferData();
    }, []);

    const { register, handleSubmit, setError, reset, formState: {errors, isSubmitting, isSubmitted, isSubmitSuccessful }  } = useForm({
        mode: 'onChange',
        defaultValues: "",
  })

    const loadOfferData = async () =>  {
  
  
        const ref = collection(db, 'offreDemploi');
        const querySnapshot = await getDocs(ref)
        querySnapshot.forEach((doc) => {
         
            setOffer(offer => [doc.data(), ...offer])
           
        }) 
    
    }

    const onSubmit = async data  => {


 

    try {
        setNom(data.nom.toUpperCase())
        console.log(nom);
        console.log(offer);
        setUser(nom);
        
            

      }
              catch(err) {
              console.log(err);
           

          }
      
          formRef.current.reset();
          console.log(user)
          
}
    return (
        <div>

        {user === nom ? "" : 
            <form className={user === true ? "disabled" : "form"} ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                <label>Nom de votre organisme/entreprise</label>
                <div className="try">
                <AiOutlineInfoCircle />
                <p>il est possible que le serveur ne réponde pas de suite, si rien ne s'affiche, essayez une nouvelle fois</p>
                </div>
               
                <input minLength={1} required {...register('nom')} type="text" />
                <button>Envoyer</button>
            </form>
            }
           
            {user && 
            <div>
            <button onClick={() => setUser(false)}>Retour</button>
                <p id='info'>Si vous souhaitez modifier ou supprimer une offre, il vous suffit de cliquer sur celle que vous souhaitez éditez</p>
            <div className="container">
                {offer.filter(item => item.STRUCTURE.includes(nom)).map( item => (
                <Link to={`/offre/${item.ID}`}>
                   
                    <div className="offer" key={item.INTITULE + item.CONTACT}>
                       <h2>{item.INTITULE}</h2>     
                       <h4>Organisme :</h4>     
                       <span>{item.STRUCTURE}</span>
                       <h4>Type de Contrat : </h4>
                       <span>{item.CONTRAT}</span> 
                       <div className="mission">
                        <h4>La Mission :</h4>  
                        <p>{item.MISSION}</p>
                       </div>  
                       <h4>Compétences requises :</h4>     
                       <span>{item.COMPETENCES}</span> 
                       <h4>Conditions Particulières : </h4>    
                       <span>{item.CONDITIONS}</span> 
                       <h4>Contact : </h4>     
                       <span>{item.CONTACT}</span>  
                    </div>
                 </Link>
                ))}
            </div> 
             </div>
           
            }
        </div>
    )
};

export default MurDesOffres;